/**
 * @generated SignedSource<<1ced83c73b72f53c3b95cc987736af1c>>
 * @relayHash 7259ef665e5c8073bbb954e5173d18c7
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 7259ef665e5c8073bbb954e5173d18c7

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccnId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contractId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siret"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      },
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      },
      {
        "kind": "Variable",
        "name": "siret",
        "variableName": "siret"
      }
    ],
    "kind": "ScalarField",
    "name": "availableOfferTypes",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "getAvailableOfferTypesQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "getAvailableOfferTypesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "7259ef665e5c8073bbb954e5173d18c7",
    "metadata": {},
    "name": "getAvailableOfferTypesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "25ec9cdb797deaa1fd6e86e0843c4fe1";

export default node;
